exports.chatbot = (function ($) {
    var init = function() {
        try {
            /*scroll action*/
            var scrolledTop;
            $(window).scroll(function(){
                if(scrolledTop < $(this).scrollTop()){
                    $('.chatbot_link').css('display', 'none');
                }else{
                    $('.chatbot_link').css('display', 'block');
                }
                scrolledTop = $(this).scrollTop();
            });

            /*
            var didScroll;
            var lastScrollTop = 0;
            var delta = 5;

            $(window).scroll(function(event) {
                didScroll = true;
            });
            setInterval(function() {
                if (didScroll) {
                    // hasScrolled();
                    didScroll = false;
                }
            }, 250);

            function hasScrolled() {
                var st = $(this).scrollTop();

                if (Math.abs(lastScrollTop - st) <= delta) return;
                if (st > lastScrollTop) {
                    // Scroll Down
                    if($('.chatbot_link').attr('data-state') === 'button'){
                        $('.chatbot_link').addClass('down');
                    }
                } else {
                    // Scroll Up
                    if (st + $(window).height() < $(document).height()) {
                        $('.chatbot_link').removeClass('down');
                    }
                }
                lastScrollTop = st;
            }
            */

            $('.chatbot_link').on({
                mouseenter : function(){
                    $(this).toggleClass('small-btn');
                },
                mouseleave : function(){
                    $(this).toggleClass('small-btn');
                }
            });

            $('.chatbot_link .toggle').on('click', function() {
                var button = $(this).closest('.chatbot_link').attr('data-state');
                if (button === 'button') {
                    $(this).closest('.chatbot_link').attr('data-state', '');
                    $('.chat-area').css('display', 'block');
                } else {
                    $(this).closest('.chatbot_link').attr('data-state', 'button');
                }
            });

            /*
            $('.chatbot_link .caution .css_btn_close').on('click',function(){
                $(this).closest('.caution').addClass('none_view');
            });

            $('.chatbot_link .tabs li').each(function(e) {
                var index = $(this).index();
                if ($(this).hasClass('is-selected')) {
                    $(this).closest('.chatbot_link').find('.list > *').removeClass('on');
                    $(this).closest('.chatbot_link').find('.list > *').eq(index).addClass('on');
                }
                $(this).on('click', function() {
                    $(this).addClass('is-selected').siblings().removeClass('is-selected');
                    $(this).closest('.chatbot_link').find('.list > *').removeClass('on');
                    $(this).closest('.chatbot_link').find('.list > *').eq(index).addClass('on');
                });
            });

            $('.chatbot_link .account > ul > li').each(function() {
                $(this).find('>button').on('click', function() {
                    $(this).closest('li').toggleClass('on');
                    return false;
                });
            });
            */

        } catch (ex) {
            console && console.error && console.error(ex);
        }
    };

    return {
        init: function() {
            init();
        }
    }

}(jQuery));



//////////////////
// WEBPACK FOOTER
// ./src/app/shared/services/src/3rdPartyScript/chatbotConfig.js
// module id = ./src/app/shared/services/src/3rdPartyScript/chatbotConfig.js
// module chunks = main